import { render, staticRenderFns } from "./siderbar.vue?vue&type=template&id=51b2682c"
import script from "./siderbar.vue?vue&type=script&lang=js"
export * from "./siderbar.vue?vue&type=script&lang=js"
import style0 from "./siderbar.vue?vue&type=style&index=0&id=51b2682c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports